module.exports = __webpack_public_path__ + "static/img/05.f017f43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/05.jpg
// module id = hLY+
// module chunks = 0